import { Stack, Typography } from '@mui/material'
interface ITextFieldCardProps {
    id?: string
    description: string
    text?: string
}
export const TextFieldCard = ({
    id,
    description,
    text,
}: ITextFieldCardProps) => {
    if (!text) return null
    return (
        <Stack>
            <Typography
                id={`${id}${description.toLowerCase()}-label`}
                variant={'bodySubtextBold'}
            >
                {description}
            </Typography>
            <Typography
                id={`${id}${description.toLowerCase()}-text`}
                variant={'bodyRegular'}
            >
                {text}
            </Typography>
        </Stack>
    )
}
